import React from 'react';
import { Text } from 'Components/frameworks/text/Text';
import { Modal } from 'Components/frameworks/modal/Modal';
import moment from 'moment';
import { t } from 'Src/i18n';
import { TemplateString } from 'Components/frameworks/template-string/TemplateString';
const PLEDG_INSTALLMENT_COUNT = 4;
type PledgTimelinesModalProps = {
  onCloseModal: () => void;
  installment: Array<{
    amount_cents: number;
    fees: number;
    payment_date: string;
  }>;
  total: number;
};

const formatPrice = (price) => (price / 100).toLocaleString('fr-FR');

export const PledgTimelinesModal = ({
  onCloseModal,
  installment,
  total,
}: PledgTimelinesModalProps) => {
  return (
    <Modal className="p-10" size="small" onClose={onCloseModal}>
      <div className="flex flex-col items-center p-20" data-testid="pledg-instalments">
        <Text className="pb-20 text-12" text={t('booking.banking.paymentSchedule.bnpl.title')} />
        <div className="flex w-full flex-col">
          <div className="flex flex-col pb-40 text-center">
            <TemplateString
              className="font-bold"
              template={t('booking.banking.paymentSchedule.bnpl.orderAmount')}
              values={{
                amount: total,
              }}
            />
            <TemplateString
              className="font-bold text-sienna"
              template={t('booking.banking.paymentSchedule.bnpl.subtitle')}
              values={{
                count: PLEDG_INSTALLMENT_COUNT,
              }}
            />
          </div>

          {installment.map(({ amount_cents: amount, fees, payment_date: date }, index) => (
            <div key={date} className="flex justify-between pb-20 text-14">
              <div className="flex flex-col">
                <TemplateString
                  values={{
                    count: index + 1,
                  }}
                  template={`${t(index ? 'booking.banking.paymentSchedule.bnpl.otherInstallment' : 'booking.banking.paymentSchedule.bnpl.firstInstallment')}`}
                />
                <TemplateString
                  values={{
                    date: moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY'),
                  }}
                  valuesClassName={{
                    date: 'font-bold',
                  }}
                  template={`${t('common.transport.onDate').toLowerCase()}`}
                />
              </div>
              <div className="text-right">
                <Text
                  className="text-12 font-bold text-sienna"
                  text={`${formatPrice(amount + fees)} €`}
                />
                {!!fees && (
                  <TemplateString
                    values={{
                      amount: formatPrice(fees),
                    }}
                    className="text-10"
                    template={`${t('booking.banking.paymentSchedule.bnpl.feesInclude')}`}
                  />
                )}
              </div>
            </div>
          ))}
        </div>
        <span className="pb-10 pt-20 text-justify text-10 text-mediumGrey">
          {t('booking.banking.paymentSchedule.bnpl.legalpledg')}
        </span>
      </div>
    </Modal>
  );
};
